import EmptyInbox from './EmptyInbox'
import css from './MessageCenter.scss'

interface MessageCenterProps {
  // will create message type later
  messages?: Array<unknown>
}

const MessageCenter = ({ messages = [] }: MessageCenterProps) => (
  <>
    <h5 className={css.dropdownHeader}>Notifications</h5>
    {(!messages || messages.length === 0) && <EmptyInbox />}
  </>
)

export default MessageCenter
